import { render } from "./CoockieBar.vue?vue&type=template&id=109ec028&scoped=true&ts=true"
import script from "./CoockieBar.vue?vue&type=script&lang=ts"
export * from "./CoockieBar.vue?vue&type=script&lang=ts"

import "./CoockieBar.vue?vue&type=style&index=0&id=109ec028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109ec028"]])

export default __exports__